"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _Icon = require("../../media/icon/Icon");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Switch = _interopRequireWildcard(require("@radix-ui/react-switch"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledToggle = _styledComponents.default.div.withConfig({
  displayName: "Toggle__StyledToggle",
  componentId: "sc-1hi0140-0"
})(["display:flex;flex-direction:column;position:relative;"]);
var ToggleContainer = (0, _styledComponents.default)(Switch.Root).withConfig({
  displayName: "Toggle__ToggleContainer",
  componentId: "sc-1hi0140-1"
})(["height:20px;width:40px;margin-left:", ";border:", " solid ", ";border-radius:", ";background-color:", ";position:relative;display:inline-block;cursor:", ";transition:0.2s;outline:none;display:flex;flex-direction:column;&:focus{border:", " solid ", ";}"], _tokens.default.sky.sys.spacing['200'], _tokens.default.sky.sys.size.borderwidth.thin, function (_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    error = _ref.error;
  return disabled ? _tokens.default.sky.sys.color.border.disabledondisabled : error ? _tokens.default.sky.sys.color.border.error : checked ? _tokens.default.sky.sys.color.border.active : _tokens.default.sky.sys.color.border.enabled;
}, _tokens.default.sky.sys.size.borderradius[5], function (_ref2) {
  var checked = _ref2.checked,
    error = _ref2.error,
    disabled = _ref2.disabled;
  return disabled ? _tokens.default.sky.sys.color.background.disabled[1] : error ? _tokens.default.sky.sys.color.background.semantic.error[1] : checked ? _tokens.default.sky.sys.color.background.primary[3] : _tokens.default.sky.sys.color.background.neutral[1];
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, _tokens.default.sky.sys.size.borderwidth.thick, _tokens.default.sky.sys.color.border.focusring);
var ToggleSlider = (0, _styledComponents.default)(Switch.Thumb).withConfig({
  displayName: "Toggle__ToggleSlider",
  componentId: "sc-1hi0140-2"
})(["position:absolute;transform:translateY(-50%);top:50%;", ";width:13.33px;height:13.33px;", " background-color:", ";border-radius:26px;transition:0.2s;display:flex;align-items:center;justify-content:center;"], function (_ref4) {
  var checked = _ref4.checked;
  return checked ? 'right: 4px' : 'left: 4px';
}, function (_ref5) {
  var error = _ref5.error,
    disabled = _ref5.disabled;
  return disabled ? "border: ".concat(_tokens.default.sky.sys.size.borderwidth.thin, " solid\n\t\t").concat(_tokens.default.sky.sys.color.border.disabledondisabled, ";") : !error && "border: ".concat(_tokens.default.sky.sys.size.borderwidth.thin, " solid\n\t\t\t").concat(_tokens.default.sky.sys.color.border.enabled, ";");
}, function (_ref6) {
  var checked = _ref6.checked,
    disabled = _ref6.disabled,
    error = _ref6.error;
  return disabled ? '#ffffff' : error ? _tokens.default.sky.sys.color.background.semantic.error[2] : checked ? '#ffffff' : _tokens.default.sky.sys.color.background.neutral[3];
});
var ToggleLabel = _styledComponents.default.label.withConfig({
  displayName: "Toggle__ToggleLabel",
  componentId: "sc-1hi0140-3"
})(["display:flex;"]);
var Toggle = function Toggle(_ref7) {
  var children = _ref7.children,
    checked = _ref7.checked,
    onChange = _ref7.onChange,
    _ref7$disabled = _ref7.disabled,
    disabled = _ref7$disabled === void 0 ? false : _ref7$disabled,
    _ref7$error = _ref7.error,
    error = _ref7$error === void 0 ? false : _ref7$error,
    cy = _ref7.cy;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledToggle, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ToggleLabel, {
      children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(ToggleContainer, {
        checked: checked,
        disabled: disabled,
        error: error,
        onCheckedChange: function onCheckedChange() {
          return onChange(!checked);
        },
        "aria-label": 'toggle',
        "data-cy": cy,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ToggleSlider, {
          checked: checked,
          disabled: disabled,
          error: error,
          children: error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            size: 's',
            color: 'white',
            icon: 'closeS'
          })
        })
      })]
    })
  });
};
var _default = exports.default = Toggle;